import React from 'react';

const defaultColor = '#666';

export const Info = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="14"
        height="14"
        viewBox="0 0 14 14"
    >
        <defs>
            <path
                id="gs8whhrd3a"
                d="M7 0c3.865 0 7 3.135 7 7s-3.135 7-7 7-7-3.134-7-7 3.135-7 7-7zm0 1C3.691 1 1 3.691 1 7s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm.75 4.477v5.521h-1.5V6.477h-.499v-1H7.75zm0-2.479v1.5h-1.5v-1.5h1.5z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g>
                            <g>
                                <g transform="translate(-742 -647) translate(157 230) translate(17) translate(0 31) translate(503 381) translate(65 5)">
                                    <use fill={fill} fillRule="nonzero" xlinkHref="#gs8whhrd3a" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Vip = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="20"
        height="20"
        viewBox="0 0 20 20"
    >
        <defs>
            <path
                id="ktpiu5affa"
                d="M4.355 6.74C3.59 6.03 3.11 5.014 3.11 3.888 3.111 1.74 4.852 0 7 0c2.148 0 3.889 1.741 3.889 3.889 0 1.126-.479 2.14-1.244 2.85C12.2 7.783 14 10.292 14 13.222c0 .43-.348.778-.778.778-.43 0-.778-.348-.778-.778 0-3.007-2.437-5.444-5.444-5.444s-5.444 2.437-5.444 5.444c0 .43-.349.778-.778.778-.43 0-.778-.348-.778-.778 0-2.93 1.8-5.44 4.355-6.483zM7 6.221c1.289 0 2.333-1.044 2.333-2.333C9.333 2.6 8.29 1.556 7 1.556c-1.289 0-2.333 1.044-2.333 2.333C4.667 5.178 5.71 6.222 7 6.222z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g transform="translate(-250 -310) translate(253 313)">
                    <use fill={fill} fillRule="nonzero" xlinkHref="#ktpiu5affa" />
                </g>
            </g>
        </g>
    </svg>
);

export const Cruise = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="18"
            height="16"
            viewBox="0 0 18 16"
        >
            <defs>
                <path
                    id="n9srestnwa"
                    d="M17.809 11.688H1.187v4.25H14.82c.633 0 1.256-.022 2.255-1.087l1.921-2.076c.004-.6-.528-1.088-1.187-1.088zm-.328 1.062l-1.312 1.415c-.62.663-.873.707-1.263.71H2.375V12.75h15.106zm-3.825.531c-.328 0-.594.238-.594.531 0 .294.266.532.594.532.328 0 .594-.238.594-.531 0-.294-.266-.532-.594-.532zm2.373-3.719c.329 0 .596.24.596.532 0 .292-.267.531-.596.531H1.188V9.562zm-1.184-2.124c.325 0 .592.238.592.53 0 .294-.267.532-.592.532H1.187V7.437zm-1.186-2.125c.326 0 .591.238.591.53 0 .294-.265.532-.591.532H1.187V5.312zm-7.722-4.25V4.25H4.75V1.062h1.188zm-2.968 0V4.25H1.78V1.062H2.97zm5.937 0V4.25H7.72V1.062h1.187zm2.969 0V4.25h-1.188V1.062h1.188z"
                />
            </defs>
            <g fill="none" fillRule="evenodd">
                <g>
                    <g>
                        <g transform="translate(-350 -356) translate(340 351) translate(9 4.6)">
                            <use fill={fill} fillRule="nonzero" xlinkHref="#n9srestnwa" />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const AirPlane = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="18"
        height="18"
        viewBox="0 0 18 18"
    >
        <defs>
            <path
                id="q8n8cqofpa"
                d="M15.322 5.299h-3.834L9.168.25H6.37l1.234 5.049H1.431C1.133 4.66.692 4.104.125 3.697v1.437c.403.511.656 1.15.656 1.853C.78 7.69.528 8.33.125 8.841v1.436c.567-.406 1.008-.962 1.306-1.602H7.61L6.37 13.75h2.797l2.33-5.074h3.821c.926 0 1.679-.756 1.679-1.688 0-.933-.75-1.689-1.677-1.689zm0 2.332h-4.494l-2.33 5.072h-.794l1.24-5.072H1.917c.03-.214.044-.427.044-.641 0-.214-.015-.428-.044-.641h7.021l-1.234-5.05h.792l2.32 5.047h4.505c.35 0 .634.288.634.642-.001.353-.287.643-.633.643z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g>
                            <g transform="translate(-531 -180) translate(204 177) translate(317) translate(10 3) translate(1 2)">
                                <use fill={fill} fillRule="nonzero" xlinkHref="#q8n8cqofpa" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Bus = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="14"
        viewBox="0 0 16 14"
    >
        <defs>
            <path
                id="n4b5ygjrka"
                d="M14.751 4.951h-.91V2.536c0-.569-.602-.898-1.17-1.03 0 0-2.131-.516-4.622-.516-2.49 0-4.72.516-4.72.516-.62.157-1.17.461-1.17 1.03v2.415h-.91c-.31 0-.562.222-.562.495v1.98c1.088 0 1.123-1.485 1.123-1.485h.35v6.394c0 .57.523 1.031 1.168 1.031h.183v.485c0 .273.251.495.561.495.31 0 .561-.222.561-.495v-.485h6.734v.495c0 .273.251.495.56.495.31 0 .562-.222.562-.495v-.495h.183c.645 0 1.168-.461 1.168-1.03V5.94h.35s.035 1.485 1.123 1.485v-1.98c0-.273-.252-.495-.562-.495zm-2.033 7.425v.022l-9.436-.022v-2.97h9.436v2.97zm0-3.96H3.282v-2.97h9.436v2.97zM5.475 9.901c.465 0 .842.332.842.742s-.377.743-.842.743c-.465 0-.842-.332-.842-.743 0-.41.377-.742.842-.742zm5.05 0c.465 0 .842.332.842.742s-.377.743-.842.743c-.465 0-.842-.332-.842-.743 0-.41.377-.742.842-.742zm-2.476-7.92c2.298 0 4.308.475 4.337.482.167.04.28.095.332.13v1.863H3.282V2.59c.053-.032.16-.082.329-.126.021-.005 2.132-.483 4.438-.483zm2.195.742H5.756v.99h4.488v-.99z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g transform="translate(-318 -144) translate(204 140) translate(102) translate(12 3.52)">
                            <use fill={fill} fillRule="nonzero" xlinkHref="#n4b5ygjrka" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Train = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="17"
        viewBox="0 0 16 17"
    >
        <defs>
            <path
                id="jx2taawqda"
                d="M3.5 2.938v8.437c0 .621.507 1.125 1.132 1.125h6.737c.625 0 1.131-.504 1.131-1.125V2.937c0-.62-.506-1.124-1.13-1.124H4.631c-.625 0-1.132.504-1.132 1.125zm7.875 0l-.006 8.437H4.625l.007-8.438h6.743zM10.25 4.062h-4.5v3.375h4.5V4.063zm-3.938 9L4.625 14.75h6.75l-1.688-1.688h1.688L15.313 17h-1.688L12.5 15.875h-9L2.375 17H.687l3.938-3.938h1.688zm0-3.937c.317 0 .563.255.563.563 0 .307-.246.562-.563.562-.316 0-.562-.255-.562-.563 0-.307.246-.562.563-.562zm3.375 0c.317 0 .563.255.563.563 0 .307-.246.562-.563.562-.316 0-.562-.255-.562-.563 0-.307.246-.562.563-.562zm-.562-3.938v1.125h-2.25V5.188h2.25zM6.312.125c.317 0 .563.255.563.563 0 .307-.246.562-.563.562-.316 0-.562-.255-.562-.563 0-.307.246-.562.563-.562zm3.375 0c.317 0 .563.255.563.563 0 .307-.246.562-.563.562-.316 0-.562-.255-.562-.563 0-.307.246-.562.563-.562z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g transform="translate(-213 -142) translate(204 140) translate(8 1) translate(1 1)">
                            <use fill={fill} fillRule="nonzero" xlinkHref="#jx2taawqda" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Lion = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
            <g fill={fill}>
                <g>
                    <g>
                        <g>
                            <path
                                d="M19.056 7.346c-1.617-.64-1.858-2.164-3.87-4.106-1.056-1.018-2.346-1.514-3.608-1.514-.4 0-.798.05-1.185.15-.978.25-1.455.756-1.646 1.017.41.092.809.282 1.114.767.25.399.291.943.142 1.445-.049.163-.117.292-.201.441.233-.036.47-.06.718-.06 1.336 0 2.772.52 4.196 1.498.798.547 1.603 1.153 2.8 1.153.895 0 1.465-.406 1.616-.568.07-.077.066-.168-.076-.223"
                                transform="translate(-225 -545) translate(218 542) translate(7 3) translate(0 2)"
                            />
                            <path
                                d="M5.35 5.474c-.388-.147-.712-.476-.712-.476.004-.176.413-.396.89-.396.229 0 .474.051.698.182-.13.3-.739.64-.876.69m3.086.384c.627-.287 1.155-1.204.792-1.788-.298-.48-.808-.56-1.41-.56-.144 0-.29.016-.514.032-.943.067-7.122.876-7.18.915-.046.032-.107.108-.056.297.048.18.277.526.914.73-.076.048-.294.086-.475.07-.307-.027-.478-.1-.478-.1s-.161 1.92.278 2.683c.278.485.617.426 1.313.46.593.032.787.092.981.295.114.119.224.346.121.351-.311-.004-.496-.024-.733-.018-.222.006-.414.022-.656.1-.223.074-.584.345-.737 1.19-.051.281-.14 1.104.097 1.28.089.065.363.072.806.072l.944.008c.197 0 .299-.062.425-.198.334-.36 1.057-1.007 2.243-1.455 1.687-.636 2.005-.968 2.63-1.734.74-.91.695-2.63.695-2.63M19.363 9.697c-.07.006-.152.036-.426.038-.765.002-2.231-.302-4.116-1.77-1.537-1.197-3.038-1.748-4.3-1.748-.5 0-.94.064-1.372.255-.055.825-.25 1.678-.819 2.447-.327.442-.617.753-.995 1.02 1.365.084 2.917.986 3.651 1.394 2.117 1.176 3.51 1.451 4.476 1.446 2.465-.013 3.791-1.804 3.995-2.795.044-.212.013-.296-.094-.287M14.996 13.78c-.822-.112-2.096-.42-4.346-1.759-.584-.347-1.086-.608-1.573-.826-.82-.366-1.528-.551-2.22-.551-.778.007-1.433.21-2.187.593-1.267.643-1.99 1.989-2.174 2.374-.07.145.02.197.103.203.579.04 1.523.208 2.725.68 1.748.686 3.265 1.413 5.155 1.473 2.32.073 4.096-1.243 4.558-1.867.126-.17.137-.295-.04-.32M12.882.904C12.2.42 11.03 0 9.657 0c-.547 0-1.123.075-1.71.257C5.79.927 4.879 2.365 4.6 3.1c.714-.09 2.45-.309 3.362-.321.102-.196.613-1.19 2.25-1.612.444-.114.85-.174 1.312-.174.395 0 .921.062 1.273.14.008.001.005 0 0 0 .142.025.202-.147.085-.23"
                                transform="translate(-225 -545) translate(218 542) translate(7 3) translate(0 2)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Time = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <defs>
            <path
                id="6wodv5xvqa"
                d="M7 0C3.135 0 0 3.135 0 7s3.135 7 7 7 7-3.135 7-7-3.135-7-7-7zm0 1.166c3.217 0 5.833 2.617 5.833 5.834 0 3.217-2.616 5.834-5.833 5.834S1.167 10.217 1.167 7c0-3.217 2.616-5.834 5.833-5.834zM7.191 3h-1v4.641c0 .132.053.259.146.354.094.094.221.146.354.146l3.678-.002v-1l-3.178.002V3z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g transform="translate(-560 -470) translate(560 460) translate(1 11)">
                        <use fill={fill} fillRule="nonzero" xlinkHref="#6wodv5xvqa" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Calendar = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <defs>
            <path
                id="nd3y8wukka"
                d="M13.001 1H12.5V0h-1v1h-9V0h-1v1H1c-.552 0-1 .537-1 1.2v9.6c0 .663.448 1.2 1 1.2h12.001c.551 0 .999-.537.999-1.2V2.2c0-.663-.448-1.2-.999-1.2zM1 6h12v6H1V6zm8.229.718l.707.707-3.416 3.417c-.094.093-.221.146-.354.146-.133 0-.26-.052-.354-.146L4.064 9.093l.707-.707 1.395 1.395 3.063-3.063zM13 2l.021.031L13 5H1V2h12z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g transform="translate(-670 -432) translate(670 430) translate(0 2) translate(1 1)">
                            <use fill={fill} fillRule="nonzero" xlinkHref="#nd3y8wukka" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const List = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g fill="none" fillRule="evenodd">
            <g fill={fill} fillRule="nonzero">
                <g>
                    <g>
                        <g>
                            <path
                                d="M.406 1.3h12.188c.224 0 .406-.291.406-.65 0-.359-.182-.65-.406-.65H.406C.182 0 0 .291 0 .65c0 .359.182.65.406.65zM.389 4.55h8.16c.215 0 .389-.291.389-.65 0-.359-.174-.65-.39-.65H.389C.175 3.25 0 3.541 0 3.9c0 .359.174.65.389.65zM12.594 6.5H.406C.182 6.5 0 6.791 0 7.15c0 .359.182.65.406.65h12.188c.224 0 .406-.291.406-.65 0-.359-.182-.65-.406-.65zM6.08 9.75H.42c-.232 0-.42.291-.42.65 0 .359.188.65.42.65h5.66c.232 0 .42-.291.42-.65 0-.359-.188-.65-.42-.65z"
                                transform="translate(-560 -432) translate(560 430) translate(0 2) translate(2 2)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const HollowHeart = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
            <g fillRule="nonzero" stroke={fill}>
                <g>
                    <g>
                        <path
                            d="M13.344 2.035c-1.193 0-2.385.526-3.294 1.576l-.014.017C9.106 2.55 7.856 2 6.613 2c-1.184 0-2.36.5-3.248 1.528-1.82 2.099-1.82 5.506 0 7.607L10.075 18l6.545-6.764.015-.018c1.82-2.1 1.82-5.506 0-7.606-.91-1.051-2.099-1.577-3.291-1.577z"
                            transform="translate(-289 -428) translate(222 428) translate(67)"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const FillHeart = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
            <g fill={fill} fillRule="nonzero">
                <g>
                    <g>
                        <path
                            d="M13.344 2.035c-1.193 0-2.385.526-3.294 1.576l-.014.017C9.106 2.55 7.856 2 6.613 2c-1.184 0-2.36.5-3.248 1.528-1.82 2.099-1.82 5.506 0 7.607L10.075 18l6.545-6.764.015-.018c1.82-2.1 1.82-5.506 0-7.606-.91-1.051-2.099-1.577-3.291-1.577z"
                            transform="translate(-289 -466) translate(222 428) translate(67 38)"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Boat = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <defs>
            <path
                id="t47q4et2xa"
                d="M14.994 4h-1.066l-2.351-2.801C10.948.365 10.565 0 9.531 0H1.01v1h2.1l-.743 3H0l1.006 3.966C1.285 8.585 1.676 9 2.533 9h9.152c.533 0 1.06-.02 1.906-1.033L16 5.033C16 4.462 15.551 4 14.994 4zM8.088 1h1.443c.555 0 .685.054 1.264.821L12.623 4H7.345l.743-3zM4.141 1h2.917l-.743 3H3.397l.744-3zm10.591 4l-1.911 2.327C12.259 8 12.056 8 11.686 8H2.533c-.308 0-.418-.038-.578-.369L1.288 5h13.444zM11 6c-.276 0-.5.224-.5.5s.224.5.5.5.5-.224.5-.5-.224-.5-.5-.5z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g transform="translate(-319 -255) translate(319 255) translate(0 4)">
                        <use fill={fill} fillRule="nonzero" xlinkHref="#t47q4et2xa" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Walk = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <defs>
            <path
                id="a95wjuh6ca"
                d="M4.842 10.073l.67.743-3.535 3.199s.61.485.376.485h-1.25l-.189-.874 3.928-3.553zm1.33-6.489c.801 0 1.453.652 1.453 1.453 0 .038-1.078 4.738-1.078 4.738l1.244 1.37 1.741 2.863s.868.492.571.492h-1.5l-1.61-2.761L4.37 8.863c-.11-.12-.154-.285-.119-.444l.723-3.286L.947 7.148.5 6.253 5.466 3.77c.005-.002.01 0 .014-.002.207-.114.44-.184.692-.184zm2.175 1.17c.2.04.529.16.829.248.715.21 1.696.498 2.693.498v1c-1.142 0-2.202-.312-2.975-.539-.266-.079-.566-.191-.744-.227zM6.854.5c.414 0 .749.56.749 1.25S7.268 3 6.854 3s-.749-.56-.749-1.25S6.44.5 6.854.5z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g transform="translate(-354 -255) translate(353.5 254.5) translate(2.5 .5)">
                        <use fill={fill} fillRule="nonzero" xlinkHref="#a95wjuh6ca" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Difference = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <defs>
            <path
                id="w31zd2ou7a"
                d="M8 1C4.135 1 1 4.134 1 8s3.135 7 7 7 7-3.134 7-7-3.135-7-7-7zm0 1.167c3.217 0 5.833 2.617 5.833 5.833S11.217 13.833 8 13.833 2.167 11.216 2.167 8 4.783 2.167 8 2.167zm2.229 3.772L7.166 9.001 5.771 7.606l-.707.707 1.748 1.75c.094.094.221.146.354.146.133 0 .26-.053.354-.146l3.416-3.417-.707-.707z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g
                        fill={fill}
                        fontFamily="MicrosoftJhengHeiBold, Microsoft JhengHei"
                        fontSize="14"
                        fontWeight="bold"
                    >
                        <text transform="translate(-560 -395) translate(560 394) translate(12)">
                            <tspan x="5.5" y="15">
                                行程差別
                            </tspan>
                        </text>
                    </g>
                    <g transform="translate(-560 -395) translate(560 394) translate(0 1)">
                        <mask id="ig7f48ywnb" fill="#fff">
                            <use xlinkHref="#w31zd2ou7a" />
                        </mask>
                        <use fill={fill} fillRule="nonzero" xlinkHref="#w31zd2ou7a" />
                        <g fill={fill} mask="url(#ig7f48ywnb)">
                            <path d="M0 0H16V16H0z" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Compare = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
            <g>
                <g transform="translate(-222 -428) translate(222 428)">
                    <circle cx="10" cy="10" r="8.5" stroke={fill} />
                    <path
                        fill={fill}
                        fillRule="nonzero"
                        d="M17.795 12.12h-6.712l2.034-2.028c.227-.226.228-.594.002-.82-.226-.228-.593-.23-.82-.003L9.27 12.29c-.226.226-.227.595 0 .822l3.029 3.02c.227.226.594.225.82-.002.225-.227.225-.595-.002-.821l-2.034-2.027h6.712c.32 0 .58-.26.58-.581 0-.32-.26-.58-.58-.58z"
                    />
                    <path
                        fill={fill}
                        fillRule="nonzero"
                        d="M10.268 6.72H3.787l2.218-2.028c.248-.226.249-.594.002-.82-.246-.228-.646-.23-.894-.003L1.81 6.89c-.247.226-.248.595 0 .822l3.304 3.02c.247.226.648.225.894-.002.247-.227.246-.595-.002-.821L3.787 7.88h6.48c.35 0 .633-.26.633-.581 0-.32-.283-.58-.632-.58z"
                        transform="matrix(-1 0 0 1 12.523 0)"
                    />
                </g>
            </g>
        </g>
    </svg>
);

export const Flag = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="10"
        height="15"
        viewBox="0 0 10 15"
    >
        <defs>
            <path
                id="qwvk2qrh5a"
                d="M4 2.5v-.999C4 1.224 3.776 1 3.5 1s-.5.224-.5.501V15h1V9h9l-2.521-3.187L13 2.5H4zm5.693 3.934L10.934 8H4V3.5h6.982L9.681 5.208l-.47.618.482.608z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g>
                            <g>
                                <g transform="translate(-1214 -755) translate(157 230) translate(17) translate(0 506) translate(1035 18) translate(2 .5)">
                                    <use fill={fill} fillRule="nonzero" xlinkHref="#qwvk2qrh5a" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const ArrowRight = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <path
                            d="M0 0H25V25H0z"
                            transform="translate(-387 -613) translate(219 613) matrix(-1 0 0 1 193 0)"
                        />
                        <path
                            fill={fill}
                            fillRule="nonzero"
                            d="M19.001 17.333l-6.705-6.643-6.705 6.643L4 15.758l7.5-7.431c.44-.436 1.153-.436 1.592 0l7.5 7.43-1.59 1.576z"
                            transform="translate(-387 -613) translate(219 613) matrix(-1 0 0 1 193 0) matrix(0 1 1 0 -.37 .37)"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const ArrowLeft = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26">
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <path d="M0 0H25V25H0z" transform="translate(-219 -613) translate(219 613)" />
                    <path
                        fill={fill}
                        fillRule="nonzero"
                        d="M17.858 17l-5.747-5.694L6.364 17 5 15.65l6.43-6.37c.376-.373.986-.373 1.363 0l6.43 6.37L17.857 17z"
                        transform="translate(-219 -613) translate(219 613) matrix(0 1 1 0 -.889 .889)"
                    />
                </g>
            </g>
        </g>
    </svg>
);
export const ArrowUp = ({ fill = defaultColor, className }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={20}
        height={20}
        viewBox="0 0 20 20"
        className={className}
    >
        <defs>
            <path
                id="ArrowUp_a"
                d="M14.47 6.97l1.06 1.06-5 5.002a.749.749 0 01-1.06 0l-5-5.002 1.06-1.06L10 11.44l4.47-4.47z"
            />
        </defs>
        <g transform="matrix(1 0 0 -1 0 20)" fill="none" fillRule="evenodd">
            <mask id="ArrowUp_b" fill={fill}>
                <use xlinkHref="#ArrowUp_a" />
            </mask>
            <use fill={fill} fillRule="nonzero" xlinkHref="#ArrowUp_a" />
            <g fill="none" mask="url(#ArrowUp_b)">
                <path d="M0 0h20v20H0z" />
            </g>
        </g>
    </svg>
);
export const TagsFilter = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={34} height={34} viewBox="0 0 34 34">
        <g fill="none" fillRule="evenodd">
            <circle cx={17} cy={17} r={17} fill={fill || '#3EA5D9'} />
            <g fill="#FFF" fillRule="nonzero">
                <path d="M25.575 11.771l-1.309-1.308 1.574-1.561a.528.528 0 00-.743-.749L23.52 9.718l-1.286-1.286c-.467-.467-1.196-.558-1.815-.227l-2.387 1.247c-.618.327-.1-.105-9.658 9.45-.488.487-.493 1.24-.048 1.685l5.09 5.088c0-.015.258.325.798.325.316 0 .639-.125.887-.373l8.862-8.859c.483-.483.528-.674 1.84-3.182.33-.619.24-1.348-.228-1.815zm-.703 1.319l-1.25 2.39c-.23.428.398-.26-9.267 9.401-.106.106-.208.048-.193.048-5.462-5.46-5.11-5.084-5.107-5.148.005-.11-.547.478 8.927-8.992.337-.337.37-.314 2.928-1.65.244-.128.459-.081.578.039l1.284 1.283-.771.766c-1.29-.722-2.884.211-2.884 1.69 0 1.077.873 1.935 1.937 1.935 1.488 0 2.407-1.601 1.692-2.88l.772-.765 1.312 1.31c.136.137.153.367.042.573zm-2.935-.174c0 .782-.953 1.177-1.507.624a.88.88 0 010-1.247c.554-.554 1.507-.16 1.507.623z" />
                <path d="M17.054 14.162l-5.892 5.891a.555.555 0 00.784.785l5.892-5.891a.555.555 0 00-.784-.784zm-.019 4.004l-3.87 3.869a.567.567 0 000 .8c.221.22.579.22.8 0l3.87-3.87a.567.567 0 000-.8.567.567 0 00-.8 0z" />
            </g>
        </g>
    </svg>
);

export const Magnifier = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
        <g fill="none" fillRule="nonzero">
            <path
                fill={fill}
                d="M10.306 9.259l3.144 3.143a.74.74 0 1 1-1.048 1.048L9.26 10.306a5.556 5.556 0 1 1 1.048-1.048zm-4.417.704a4.074 4.074 0 1 0 0-8.148 4.074 4.074 0 0 0 0 8.148z"
            />
            <path d="M-1-1h16v16H-1z" />
        </g>
    </svg>
);
